import React, { useState, useEffect } from "react";
import { Typography, TextField, Button, Grid, Stepper, Step, StepLabel, DialogActions, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";

const steps = ["Datos Básicos", "Asignar Vehículo y Conductor"];

const EditarViaje = ({ viaje, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [viajeData, setViajeData] = useState({
    origen: "",
    destino: "",
    hora_salida: "",
    hora_llegada: "",
    distancia_recorrida: "",
    vehiculo: "",
    conductor: "",
    conductor_id: "",
  });
  const [vehiculos, setVehiculos] = useState([]);
  const [conductores, setConductores] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  // Fetch available vehicles and drivers
  useEffect(() => {
    api.get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));

    api.get("conductores/")
      .then((response) => setConductores(response.data))
      .catch(() => alert("Error al cargar conductores."));
  }, []);

  // Pre-fill the form with the existing viaje data
  useEffect(() => {
    if (viaje) {  
      // Pre-fill the form with the existing viaje data
      const formatDate = (date) => {
        const d = new Date(date);
        return d.toISOString().slice(0, 16); // Convert to "YYYY-MM-DDTHH:mm"
      };
  
      setViajeData({
        origen: viaje.origen,
        destino: viaje.destino,
        hora_salida: viaje.hora_salida ? formatDate(viaje.hora_salida) : "",
        hora_llegada: viaje.hora_llegada ? formatDate(viaje.hora_llegada) : "",
        distancia_recorrida: viaje.distancia_recorrida,
        vehiculo: viaje.vehiculo || "",
        conductor: viaje.conductor || "",  // This is the name of the conductor, e.g., "Juan Citox"
        conductor_id: viaje.conductor_id || "",  // This is the ID of the conductor, e.g., 1
      });
    }
  }, [viaje]);  

  // Validate Step 1 fields
  useEffect(() => {
    const { origen, destino, hora_salida, hora_llegada, distancia_recorrida } = viajeData;
    setIsStep1Valid(origen && destino && hora_salida && hora_llegada && distancia_recorrida);
  }, [viajeData]);

  const handleChange = (e) => {
    setViajeData({ ...viajeData, [e.target.name]: e.target.value });
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    api.put(`viajes/${viaje.id}/`, viajeData)
      .then((res) => {
        alert("Viaje actualizado correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch(() => alert("Hubo un error al actualizar el viaje."));
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Editar Viaje
      </Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <TextField
              label="Origen"
              name="origen"
              value={viajeData.origen}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Destino"
              name="destino"
              value={viajeData.destino}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Hora de Salida"
              name="hora_salida"
              type="datetime-local"
              value={viajeData.hora_salida}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Hora de Llegada"
              name="hora_llegada"
              type="datetime-local"
              value={viajeData.hora_llegada}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Distancia Recorrida (km)"
              name="distancia_recorrida"
              type="number"
              value={viajeData.distancia_recorrida}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo</InputLabel>
              <Select
                name="vehiculo_id"
                value={viajeData.vehiculo}
                onChange={handleChange}
              >
                <MenuItem value="">Sin vehículo</MenuItem>
                {vehiculos.map((vehiculo) => (
                  <MenuItem key={vehiculo.id} value={vehiculo.id}>
                    {vehiculo.patente} - {vehiculo.marca} {vehiculo.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
                <InputLabel style={{ background: "white" }}>Conductor</InputLabel>
                <Select
                name="conductor_id"  // Use the ID for the input name
                value={viajeData.conductor_id}  // Bind the ID value here
                onChange={handleChange}
                >
                <MenuItem value="">Sin conductor</MenuItem>
                {conductores.map((conductor) => (
                    <MenuItem key={conductor.id} value={conductor.id}>
                    {conductor.nombre} {conductor.apellido}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
            </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Guardar Cambios
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default EditarViaje;
